var SVGtoPDF = require('./svg-to-pdfkit/source.js');

module.exports = SVGtoPDF;



// WEBPACK FOOTER //
// webpack://pdfmake/src/3rd-party/svg-to-pdfkit.js